import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxRepository/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function getObj (id) {
  return axios({
    url: `/sxRepository/${id}`,
    method: 'GET'
  })
}

export function addObj (params) {
  return axios({
    url: `/sxRepository/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function putObj (params) {
  return axios({
    url: `/sxRepository/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxRepository/${id}`,
    method: 'DELETE'
  })
}

export function addComment (params) {
  return axios({
    url: `/sxRepository/saveComment`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
